import { init as sentryInit, captureMessage, withScope } from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { getConfig } from '../configuration';
import formatInternalLog from '../utils/format';
const pushToSentry = (message, data, level) => {
  withScope(scope => {
    scope.setLevel(level);
    scope.setContext('data', data);
    captureMessage(message, scope);
  });
};
const check = () => {
  var _window, _window$BC_API_ENDPOI, _window$BC_API_ENDPOI2, _window2, _window2$BC_API_ENDPO, _window2$BC_API_ENDPO2;
  const appName = getConfig('appName');
  const version = getConfig('version');
  const sentryId = getConfig('sentryProjectId');
  const sentryToken = getConfig('sentryToken');
  let configIsOk = true;
  if (!appName) {
    console.error(formatInternalLog('Cannot log to Sentry as the appName is not defined'));
    configIsOk = false;
  }
  if (!version) {
    console.error(formatInternalLog('Cannot log to Sentry as the version is not defined'));
    configIsOk = false;
  }
  if (!sentryId) {
    console.error(formatInternalLog('Cannot log to Sentry as the sentryProjectId is not defined'));
    configIsOk = false;
  }
  if (!sentryToken) {
    console.error(formatInternalLog('Cannot log to Sentry as the sentryToken is not defined'));
    configIsOk = false;
  }
  if (!((_window = window) !== null && _window !== void 0 && (_window$BC_API_ENDPOI = _window.BC_API_ENDPOINTS_CONF) !== null && _window$BC_API_ENDPOI !== void 0 && (_window$BC_API_ENDPOI2 = _window$BC_API_ENDPOI.sentry) !== null && _window$BC_API_ENDPOI2 !== void 0 && _window$BC_API_ENDPOI2.url) || !((_window2 = window) !== null && _window2 !== void 0 && (_window2$BC_API_ENDPO = _window2.BC_API_ENDPOINTS_CONF) !== null && _window2$BC_API_ENDPO !== void 0 && (_window2$BC_API_ENDPO2 = _window2$BC_API_ENDPO.sentry) !== null && _window2$BC_API_ENDPO2 !== void 0 && _window2$BC_API_ENDPO2.environment)) {
    console.error(formatInternalLog('Cannot log to Sentry as the window.BC_API_ENDPOINTS_CONF.sentry.{url || environment} are not defined'));
    configIsOk = false;
  }
  return configIsOk;
};
const init = () => {
  const appName = getConfig('appName');
  const version = getConfig('version');
  const sentryId = getConfig('sentryProjectId');
  const sentryToken = getConfig('sentryToken');
  const {
    url,
    environment
  } = window.BC_API_ENDPOINTS_CONF.sentry;
  sentryInit({
    dsn: `https://${sentryToken}@${url}/${sentryId}`,
    release: `${appName}@${version}`,
    environment,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.2
  });
};
const logger = {
  key: 'sentry',
  check,
  init,
  handle: (level, message, data) => {
    switch (level) {
      case 'debug':
        pushToSentry(message, data, 'debug');
        break;
      case 'info':
        pushToSentry(message, data, 'info');
        break;
      case 'warn':
        pushToSentry(message, data, 'warning');
        break;
      case 'error':
        pushToSentry(message, data, 'error');
        break;
      default:
        console.error(formatInternalLog(`Unknown or logging not available for the level ${level}`));
    }
  }
};
export default logger;